import { IndexBalanceCheckLetter } from "components/UI/atoms";
import "./index.scss";

export const IndexBalanceCheckSearch = () => {
  const INDEX_LETTERS = "#ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

  return (
    <div className="index-balance-check-search-container">
      {INDEX_LETTERS.map((letter) => (
        <IndexBalanceCheckLetter letter={letter} key={letter} />
      ))}
    </div>
  );
};
